import cx from 'classix';

export const DirectoryOuterSection = ({
  noTopMargin,
  children,
}: {
  noTopMargin?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className='mx-auto pb-8 sm:max-w-[1216px]'>
      <div className='px-4 w-full'>
        <div
          className={cx(
            'mt-8',
            noTopMargin && 'sm:mt-0',
            'grid grid-rows-[auto-fit_1fr] sm:grid-cols-[minmax(0px,280px)_1fr] gap-6 sm:gap-8',
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
